import numeral from 'numeral';

export const keys = (t) => [
    {
        key: 'category',
        label: t('discover.overview.top_categories.category'),
        renderCell: ({ item }) => {
            return (
                <div>
                    <a
                        href={
                            `/domains/${window.info.id}/categories/category?categories:in=` +
                            window.encodeURIComponent(item.level)
                        }
                        title={item.level}
                    >
                        {item.level}
                    </a>
                </div>
            );
        },
    },
    {
        key: 'sum_impressions',
        label: t('discover.overview.top_categories.sum_impressions'),
        className: 'list-data-secondary-text',
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        key: 'rank',
        label: t('discover.overview.top_categories.rank'),
        bar: true,
        renderCell: ({ item, allData }) => {
            const max = getMax(allData);
            const percent = item.sum_impressions / max;
            return percent * 100;
        },
    },
];

export const keysPage = (t) => [
    {
        key: 'relevancy',
        label: t('discover.overview.top_categories.relevancy'),
        className: 'change up',
        renderCell: ({ data }) => numeral(data).format('0%'),
    },
    {
        renderCell: ({ item }) => {
            return (
                <div className="col-12 ms-3">
                    <a
                        href={
                            `/domains/${window.info.id}/categories/category?categories:in=` +
                            window.encodeURIComponent(item.name)
                        }
                        title={item.name}
                    >
                        {item.name}
                    </a>
                </div>
            );
        },
        label: t('discover.overview.top_categories.category'),
        key: 'name',
    },
];

function getMax(data) {
    return data?.reduce((acc, curr) => {
        if (curr.sum_impressions > acc) acc = curr.sum_impressions;
        return acc;
    }, 0);
}
